export default __webpack_public_path__ + "static/team-Ben-34f7d071f654289a34c89a350969e02c.png";